import React from "react";

class Footer extends React.Component {
    render () {
        return (
            <footer>jani@penttinen.fi</footer>
        );
    }
}
export default Footer;